"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import dynamic from "next/dynamic";
import useAMSViewListener from "@/components/third-party-scripts/google-tag-manager/useAMSViewListener";
import useScrollToTop from "@/hooks/useScrollToTop";
import { useLayout } from "@/contexts/layout-context";
const BodyScripts = dynamic(() => import("@/components/layout/body-scripts"), {
  ssr: false
});
interface IRootLayoutWrapperProps {
  children: ReactNode;
}
const LayoutWrapper = props => {
  const $ = _c(6);
  const {
    navOpen
  } = useLayout();
  useAMSViewListener();
  useScrollToTop();
  let t0;
  if ($[0] !== navOpen) {
    t0 = navOpen && <div className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-[6px]" />;
    $[0] = navOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BodyScripts />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.children || $[4] !== t0) {
    t2 = <>{t0}{props.children}{t1}</>;
    $[3] = props.children;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default LayoutWrapper;